import Parse from './Parse'
import Query from './Query'

export default
{
    Parse,
    Query,
}